import type { SleepEntity } from './entity/sleepEntity';
import type { SleepIRepository } from './entity/sleepIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 睡眠ドメインサービス
 */
export class SleepDomainService extends DomainServiceBase {
  private sleepRepository!: SleepIRepository;

  /**
   * Injection
   * @param sleepRepository sleepRepository
   */
  public inject(
    sleepRepository: SleepIRepository,
  ) {
    this.sleepRepository = sleepRepository;
  }

  /**
   * 睡眠取得
   * @param token トークン
   * @returns 一覧
   */
  async getSleepList(token: string | null) {
    const result = await this.sleepRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: SleepEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** アイテムリスト */
      items,
    };
  }

  /**
   * 指定日の睡眠リスト取得
   * @param date 日付
   * @returns リスト
   */
  async getSleepListWithDate(date: string) {
    const result = await this.sleepRepository.getAllListWithKey(date);
    const items = result.map((v: SleepEntity) => v.toJson());
    return items;
  }

  /**
   * 睡眠作成
   * @param entity 入力
   * @returns 結果
   */
  async createSleep(
    entity: SleepEntity,
  ) {
    const result = await this.sleepRepository.create(entity);
    return result;
  }

  /**
   * 睡眠更新
   * @param entity 入力
   * @returns 結果
   */
  async updateSleep(
    entity: SleepEntity,
  ) {
    const result = await this.sleepRepository.update(entity);
    return result;
  }

  /**
   * 睡眠削除
   * @param entity 入力
   * @returns 結果
   */
  async deleteSleep(
    entity: SleepEntity,
  ) {
    const result = await this.sleepRepository.delete(entity);
    return result;
  }
}
